export default {
  data: () => ({
    numberMask2: '##'
  }),
  methods: {
    //use single column grid layout for small number of referrers. This is what TD wanted for Toroexmark (limited referrers)
    //while yardcard uses 4-across (dozens of referrers)
    singleColReferrers() {
      return this.applicationReferrers.length <= 10
    },
    selectedReferrersValid() {
      if (this.programHasReferrers()) {
        return this.getSelectedReferrers().length > 0
      } else {
        return true
      }
    },
    getSelectedReferrers() {
      if (!this.applicationReferrers) return []

      return this.applicationReferrers.filter(function(r) {
         return r.selected == true
      })
    },
    programHasReferrers() {
      return this.$store.getters.getProgramReferrers && this.$store.getters.getProgramReferrers.length > 0
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/applicantMixins.js